import { render, staticRenderFns } from "./ModalComentarios.vue?vue&type=template&id=2daef762&scoped=true&"
import script from "./ModalComentarios.vue?vue&type=script&lang=js&"
export * from "./ModalComentarios.vue?vue&type=script&lang=js&"
import style0 from "./ModalComentarios.vue?vue&type=style&index=0&id=2daef762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daef762",
  null
  
)

export default component.exports